<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="group-list-content-loading" class="vs-con-loading__container">
		<vx-card
			no-shadow
			card-border
			class="custom-height"
			:title="$t('AssignedTeams.AssignedTeams') + ' ' + assignedTeams.length"
		>
			<template slot="actions" v-if="customConfig.navbarOptions">
				<div class="flex flex-row justify-between">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('AssignedTeams.AssignedTeam')"
						:text="$t('AssignedTeams.AssignedTeamToltip')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-plus"
							:disabled="activeAlert2"
							@click="showTeamList()"
						></vs-button>
					</vx-tooltip>

					<vx-tooltip
						class="cursor-pointer"
						:title="$t('Crud.Delete')"
						color="primary"
						position="bottom"
						delay=".1s"
						:text="$t('AssignedTeams.DeleteAllTeams')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-trash-2"
							@click.stop="openDeleteAllConfirm"
							v-if="assignedTeams.length > 0"
						></vs-button>
					</vx-tooltip>

					<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-layout"
						></vs-button>
						<vs-dropdown-menu style="width: 30%">
							<vx-card no-shadow :title="$t('AssignedTeams.Columns')">
								<p>{{ $t("AssignedTeams.ColumnsText") }}</p>
								<ul class="demo-alignment">
									<li>
										<vs-checkbox v-model="checkBoxID" disabled>ID</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxName">{{ $t("Name") }}</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxDescription">{{ $t("Description") }}</vs-checkbox>
									</li>
								</ul>
							</vx-card>
						</vs-dropdown-menu>
					</vs-dropdown>
					<vx-tooltip
						v-if="teamListIds.length > 0"
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Refresh')"
						:text="null"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-refresh-ccw"
							@click.stop="showTeams"
						></vs-button>
					</vx-tooltip>
				</div>
			</template>
			<vue-perfect-scrollbar class="scroll-group-area" :settings="settings">
				<vs-table ref="table" search :data="assignedTeams" v-if="assignedTeams.length > 0">
					<template slot="thead">
						<vs-th sort-key="name" v-show="checkBoxID">ID</vs-th>
						<vs-th sort-key="name" v-show="enableHeadTable('name') && checkBoxName">{{ $t("Name") }}</vs-th>
						<vs-th sort-key="description" v-show="enableHeadTable('description') && checkBoxDescription">{{
							$t("Description")
						}}</vs-th>
						<vs-th v-show="enableHeadTable('action')">{{ $t("Teams.Table.Action") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td v-show="checkBoxID">
									<p class="product-name font-medium truncate">{{ tr.id }}</p>
								</vs-td>
								<vs-td v-show="enableHeadTable('name') && checkBoxName">
									<p class="product-name font-medium truncate">{{ tr.name }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('description') && checkBoxDescription">
									<p class="product-category">{{ tr.description | title }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('action')" class="whitespace-no-wrap">
									<feather-icon
										icon="TrashIcon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-2"
										@click.stop="removeAssignedTeam(tr.id)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p v-else-if="activeAlert2">
					<vs-alert
						class="mt-2"
						style="overflow-y: auto"
						color="warning"
						:active.sync="activeAlert2"
						:title="$t('AssignedTeams.AssignTeams')"
					>
						{{ $t("Teams.ThereAreCurrentlyNoWorkTeamsAvailable") }}
						<span
							class="text-inherit underline"
							style="cursor: pointer"
							@click.prevent="goRouter('NewTeam')"
						>
							<feather-icon class="cursor-pointer underline" icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							{{ $t("Teams.AddTeam") }}
						</span>
					</vs-alert>
				</p>
				<p v-else>
					{{ $t("AssignedTeams.NoAssignedTeams") }}
				</p>
				<slot name="alert-message"> </slot>
			</vue-perfect-scrollbar>
			<vs-popup
				:fullscreen="true"
				:title="$t('Teams.ListOfTeams')"
				:active.sync="teamMounted"
				class="vs-popup--content-custom"
			>
				<teams-list
					v-if="teamMounted"
					@closePopupEmit="showPopupGroup"
					:componentParent="componentParent"
					:teamListConfig="{
						actionDropdown: true,
						btnAssign: true,
						btnAdd: false,
						columns: ['id', 'name', 'description', 'action'],
						multiple: customConfig.multiple,
						showColumns: {
							name: true,
							description: true,
							action: false,
						},
					}"
				></teams-list>
			</vs-popup>
		</vx-card>
	</div>
</template>

<script>
import moduleTeams from "@/store/teams/moduleTeams.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import TeamsList from "./TeamsList.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export default {
	mixins: [generalPurposeMixin],
	components: {
		VuePerfectScrollbar,
		TeamsList,
	},
	props: {
		customConfig: {
			columns: ["id", "name", "description", "action"],
			defaultColumns: ["id", "name", "description", "action"],
			actionDropdown: false,
			btnAssig: true,
			navbarOptions: true,
			multiple: false,
		},
		teamListIds: {
			type: Array,
			default: () => [],
		},
		isAssignedTeams: {
			type: Boolean,
			default: () => true,
		},
		componentParent: {
			type: String,
			default: "ASSIGNED_TEAMS_LIST",
		},
	},
	data() {
		return {
			activeItem: false,
			teamMounted: false,
			itemsPerPage: 10,
			isMounted: false,
			checkBoxName: true,
			checkBoxDescription: true,
			checkBoxID: true,
			teamListFetched: false,
			activeAlert2: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		assignedTeams() {
			return this.$store.state.moduleTeams.assignedTeams;
		},
		groupUpdatePermission() {
			return this.$store.getters.checkPermission("GROUPS_U");
		},
		groupDeletePermission() {
			return this.$store.getters.checkPermission("GROUPS_D");
		},
		enableHeadTable() {
			return (headName) => this.customConfig.columns.includes(headName);
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		async getAssignedTeam(id) {
			try {
				this.openLoadingContent("#group-list-content-loading");
				await this.$store.dispatch("moduleTeams/getTeamById", {id});
				this.closeLoadingContent("#group-list-content-loading");
			} catch (error) {
				this.closeLoadingContent("#group-list-content-loading");
			}
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("AssignedTeams.DeleteAllTeams") + ` "${this.$t("AssignedTeams.AssignedTeams")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleTeams/CLEAN_ASSIGNED_TEAMS");
		},
		showPopupGroup(val) {
			this.teamMounted = val;
		},
		removeAssignedTeam(id) {
			this.$store.commit("moduleTeams/REMOVE_ASSIGNED_TEAMS", id);
			this.teamMounted = false;
		},
		showTeams() {
			if (this.teamListIds && this.teamListIds.length > 0 && this.isAssignedTeams) {
				for (let item of this.teamListIds) {
					this.getAssignedTeam(item);
				}
			}
		},
		async showTeamList() {
			if (this.teamListFetched) {
				this.teamMounted = true;
				return;
			}
			this.teamListFetched = true;
			try {
				const res = await this.$store.dispatch("moduleTeams/fetchDataListItems");
				if (res.data.length > 0) {
					this.activeAlert2 = false;
					this.teamMounted = true;
				} else {
					this.activeAlert2 = true;
				}
			} catch (err) {
				console.error(err);
			}
		},
	},
	created() {
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}

		this.checkBoxNameLocal = this.customConfig.defaultColumns.includes("name");
		this.checkBoxDescription = this.customConfig.defaultColumns.includes("description");
		this.checkBoxID = this.customConfig.defaultColumns.includes("id");
	},
	mounted() {
		this.isMounted = true;
		this.showTeams();
	},
};
</script>

<style lang="scss" scoped>
.scroll-group-area {
	margin: auto;
	width: 100%;
	min-height: 300px;
	max-height: 350px;
}
</style>
